import {SENT_CREATEEMPLOYEREMAIL_STARTED, SENT_CREATEEMPLOYEREMAIL_SUCESS,SENT_CREATEEMPLOYEREMAIL_FAILED,
    SENT_CREATEEMPLOYEEEMAIL_STARTED, SENT_CREATEEMPLOYEEEMAIL_SUCESS,SENT_CREATEEMPLOYEEEMAIL_FAILED,
    SENT_CREATECASEEMAIL_STARTED, SENT_CREATECASEEMAIL_SUCESS,SENT_CREATECASEEMAIL_FAILED,
    SENT_EMPLOYMENTCREATION_STARTED,SENT_EMPLOYMENTCREATION_SUCESS,SENT_EMPLOYMENTCREATION_FAILED
} from '../actions/AddEmail';
 
const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};


export const emailData = (state = intialData, action: any) => {
    switch (action.type) {
      case SENT_CREATEEMPLOYEREMAIL_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SENT_CREATEEMPLOYEREMAIL_SUCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SENT_CREATEEMPLOYEREMAIL_FAILED:
      return {
        ...state,
        isLoading: true,
      };

      case SENT_CREATEEMPLOYEEEMAIL_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SENT_CREATEEMPLOYEEEMAIL_SUCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SENT_CREATEEMPLOYEEEMAIL_FAILED:
      return {
        ...state,
        isLoading: true,
      };

      case SENT_CREATECASEEMAIL_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SENT_CREATECASEEMAIL_SUCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SENT_CREATECASEEMAIL_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case SENT_EMPLOYMENTCREATION_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SENT_EMPLOYMENTCREATION_SUCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SENT_EMPLOYMENTCREATION_FAILED:
      return {
        ...state,
        isLoading: true,
      };
  default:
     return state;
  }
  }